module.exports = __webpack_public_path__ + "static/media/grillfeier.341ab02e.jpg";